module.exports = __webpack_public_path__ + "static/media/14UNEP21.fe466252.jpg";